import { render, staticRenderFns } from "./ListUploadedFiles.vue?vue&type=template&id=71b1f27c&scoped=true"
import script from "./ListUploadedFiles.vue?vue&type=script&lang=js"
export * from "./ListUploadedFiles.vue?vue&type=script&lang=js"
import style0 from "./ListUploadedFiles.vue?vue&type=style&index=0&id=71b1f27c&prod&scoped=true&lang=css"
import style1 from "./ListUploadedFiles.vue?vue&type=style&index=1&id=71b1f27c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b1f27c",
  null
  
)

export default component.exports